module.exports = __webpack_public_path__ + "de2c238184cdbda37d7a5121adda6c6e.svg";